import { FiSearch, FiX } from 'react-icons/fi';
import { Input, InputGroup, InputLeftElement, InputRightElement } from '@chakra-ui/react';
import { forwardRef } from 'react';

const SearchInput = forwardRef<HTMLInputElement, any>(({
  inputGroupProps,
  currentRefinement,
  placeholder,
  refine,
  onChange = (_e) => null,
  autoFocus = true,
  ...rest
}, ref) => {

  const {
    createURL,
    isSearchStalled,
    indexContextValue,
    defaultRefinement,
    ...props
  } = rest // remove things algolia passes to this component

  return (
    <InputGroup
      {...inputGroupProps}
    >
      <InputLeftElement
        p={0}
        zIndex={0}
        children={<FiSearch size={16} />}
      />
      <Input
        placeholder={placeholder}
        value={currentRefinement}
        onChange={e => {
          refine(e.target.value)
          onChange(e)
        }}
        ref={ref}
        autoFocus={autoFocus}
        {...props}
      />
      {currentRefinement && (
        <InputRightElement
          cursor='pointer'
          children={<FiX color="green.500" />}
          onClick={() => refine('')}
        />
      )}
    </InputGroup>
  );
})

// @ts-ignore
export default SearchInput;
